import Box from '@mui/material/Box';
import { keyframes } from '@mui/system';

// Horizontal light sweep on a muted background — standard skeleton UX.
// Mirrors the admin primitive; kept as a separate file so the two apps
// ship independently without cross-package imports.
const shimmerSweep = keyframes`
  0%   { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

// Reusable building block. Compose into page-level skeletons that mirror
// the real layout (same sizes + spacing + radius) so the swap from
// skeleton to content is visually smooth.
//
// Props:
//   width     — CSS value (px, %, 'auto'). Default 100%.
//   height    — CSS value. Default 16.
//   rounded   — border-radius (number → px, or CSS string). Default 8.
//   circular  — shortcut for a round/avatar skeleton.
const Shimmer = ({
  width = '100%',
  height = 16,
  rounded = 8,
  circular = false,
  sx,
  ...rest
}) => (
  <Box
    sx={{
      width,
      height,
      borderRadius: circular ? '50%' : rounded,
      // Two-stop gradient tuned to the TrustLab cream/parchment palette.
      background: 'linear-gradient(90deg, #EDE9E1 0%, #F7F3EC 40%, #EDE9E1 80%)',
      backgroundSize: '800px 100%',
      animation: `${shimmerSweep} 1.4s ease-in-out infinite`,
      display: 'block',
      flexShrink: 0,
      ...sx,
    }}
    {...rest}
  />
);

export default Shimmer;
